import CursorSkillMazeTestPage from "@faire/prototype-playground/workspace/mf/cursor-skill-maze-test";
import { Route, Switch } from "react-router-dom";

export function MirandaFittsRoutes() {
  return (
    <Switch>
      <Route
        path="/mf/cursor-skill-maze-test"
        component={CursorSkillMazeTestPage}
      />
    </Switch>
  );
}

export const slug = "mf";
